import _ from 'lodash';

export const fieldRequired = {
  required: true,
  validate: (v: any) => !_.isEmpty(v),
};

export const getIds = (item: any) =>
  Array.isArray(item) ? item.map((i) => i.id) : item.id;
